module.exports = __webpack_public_path__ + "static/media/robo-conecta-responde.a5e812c6.svg";